// @flow
import * as React from 'react'
import Cookies from 'js-cookie'
import { withWidth } from '@material-ui/core'

import styles from './styles'
import CookiesMessage from './CookiesMessage'

type Props = {
  children: React.Node,
  isAtHomePage?: boolean,
  color?: string,
  fullWidth?: boolean,
  width: string,
  freeDeliveryMessage?: boolean,
  hasNavbarFixed?: boolean,
  hasNoPadding?: boolean
}

type State = {
  hasAcceptedCookies: boolean
}

export class Wrapper extends React.Component<Props, State> {
  state = {
    hasAcceptedCookies: Cookies.get('cookie-agreed')
  }

  static defaultProps: Object

  acceptCookies: Function = () => {
    Cookies.set('cookie-agreed', true)
    this.setState({
      hasAcceptedCookies: true
    })
  }

  render () {
    return (
      <div style={styles.container(this.props.fullWidth, this.props.freeDeliveryMessage, this.props.hasNavbarFixed, this.props.hasNoPadding, this.props.width, this.props.isAtHomePage)}>
        {this.props.children}
        {
          !this.state.hasAcceptedCookies &&
          <CookiesMessage isAtHomePage={this.props.isAtHomePage} acceptCookies={this.acceptCookies} color={this.props.color} />
        }
      </div>
    )
  }
}

Wrapper.defaultProps = {
  color: 'black'
}

export default withWidth()(Wrapper)
